(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.LbVuePagination = {}));
}(this, (function (exports) { 'use strict';

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //

  var script = {
    name: 'lb-vue-pagination',
    data: function data()
    {
      return {};
    },
    props: ['totalCount', 'value', 'searchPlaceholder', 'itemsPlaceholder'],
    created: function created()
    {
      var me = this;
      me.reloadData();
    },
    watch:
    {
      'value.currentPage': function(val)
      {
        var me = this;
        me.reloadData();
      },
      'value.limit': function(val)
      {
        var me = this;
        me.reloadData();
      },
      'value.initialId': function(val)
      {
        var me = this;
        console.log(val);
        me.reloadData();
      },
      'value.query': function(val)
      {
        var me = this;

        if(me.value.searchTimeout != false) { clearTimeout(me.value.searchTimeout); }

        me.value.searchTimeout = setTimeout(function()
        {
          me.reloadData();
          me.value.searchTimeout = false;
        }, 300);
      }
    },
    methods:
    {
      reloadData: function reloadData()
      {
        var me = this;
        me.$emit('reload', null);
      }
    },
    computed:
    {
      getSearchPlaceholder: function getSearchPlaceholder()
      {
        var me = this;

        if(me.searchPlaceholder != undefined) { return me.searchPlaceholder; }
        if(me.$t != undefined) { return me.$t('SEARCH'); }
        return 'Search';
      },
      getItemsPlaceholder: function getItemsPlaceholder()
      {
        var me = this;

        if(me.itemsPlaceholder != undefined) { return me.itemsPlaceholder; }
        if(me.$t != undefined) { return me.$t('ITEMSPERPAGE'); }
        return 'Items per page';
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
  function createInjector(context) {
    return function (id, style) {
      return addStyle(id, style);
    };
  }
  var HEAD = document.head || document.getElementsByTagName('head')[0];
  var styles = {};

  function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = {
      ids: new Set(),
      styles: []
    });

    if (!style.ids.has(id)) {
      style.ids.add(id);
      var code = css.source;

      if (css.map) {
        // https://developer.chrome.com/devtools/docs/javascript-debugging
        // this makes source maps inside style tags work properly in Chrome
        code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

        code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
      }

      if (!style.element) {
        style.element = document.createElement('style');
        style.element.type = 'text/css';
        if (css.media) { style.element.setAttribute('media', css.media); }
        HEAD.appendChild(style.element);
      }

      if ('styleSheet' in style.element) {
        style.styles.push(code);
        style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
      } else {
        var index = style.ids.size - 1;
        var textNode = document.createTextNode(code);
        var nodes = style.element.childNodes;
        if (nodes[index]) { style.element.removeChild(nodes[index]); }
        if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }else { style.element.appendChild(textNode); }
      }
    }
  }

  var browser = createInjector;

  /* script */
  var __vue_script__ = script;

  /* template */
  var __vue_render__ = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "lb-pagination" }, [
      _c(
        "div",
        {
          staticClass: "pagination-container d-flex flex-row flex-wrap col-sm-12"
        },
        [
          _c("div", { staticClass: "mr-2 main-ipp" }, [
            _c("div", { staticClass: "d-flex flex-row align-content-center" }, [
              _c("label", { staticClass: "align-self-center mr-1 label-ipp" }, [
                _vm._v(_vm._s(_vm.getItemsPlaceholder) + ":")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.limit,
                      expression: "value.limit"
                    }
                  ],
                  staticClass: "form-control input-normalheight form-dropdown",
                  attrs: { size: "0" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value;
                          return val
                        });
                      _vm.$set(
                        _vm.value,
                        "limit",
                        $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                      );
                    }
                  }
                },
                [
                  _c("option", [_vm._v("25")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("50")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("100")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("200")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("500")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("1000")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("2000")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mr-2 main-search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.query,
                  expression: "value.query"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: _vm.getSearchPlaceholder },
              domProps: { value: _vm.value.query },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.value, "query", $event.target.value);
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "toggle align-self-center mr-2",
              on: { click: _vm.reloadData }
            },
            [
              _c(
                "svg",
                {
                  staticStyle: { "font-size": "1.5em" },
                  attrs: {
                    "data-v-b34144d8": "",
                    version: "1.1",
                    role: "presentation",
                    width: "20.57142857142857",
                    height: "18",
                    viewBox: "0 0 1536 1792"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M1511 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zM1536 256v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-pagination" },
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": parseInt(_vm.totalCount),
                  "per-page": parseInt(_vm.value.limit)
                },
                model: {
                  value: _vm.value.currentPage,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "currentPage", $$v);
                  },
                  expression: "value.currentPage"
                }
              })
            ],
            1
          )
        ]
      )
    ])
  };
  var __vue_staticRenderFns__ = [];
  __vue_render__._withStripped = true;

    /* style */
    var __vue_inject_styles__ = function (inject) {
      if (!inject) { return }
      inject("data-v-51422485_0", { source: ".pagination-container > div[data-v-51422485] {\n  margin-bottom: 1.5em;\n}\n.pagination-container .toggle[data-v-51422485] {\n  cursor: pointer;\n}\n.pagination-container label[data-v-51422485] {\n  white-space: nowrap;\n}\n.pagination-container ul[data-v-51422485], .pagination-container label[data-v-51422485] {\n  margin: 0;\n}\n[data-v-51422485] .main-pagination .pagination {\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(72, 72, 72, 0.1);\n  border: solid 1px #eeeeee;\n  background-color: #ffffff;\n  height: 32px;\n}\n[data-v-51422485] .main-pagination .pagination .page-item.active .page-link {\n    background-color: #fdde88;\n    border-color: #dee2e6;\n    border-radius: .25rem;\n    color: #212529;\n}\n[data-v-51422485] .main-pagination .pagination .page-link {\n    font-family: Roboto;\n    font-size: .8rem;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #9b9b9b;\n    padding: .4rem .8rem;\n}\n[data-v-51422485] .main-pagination .pagination .page-link:hover {\n      color: #004b64;\n}\n.main-search .form-control[data-v-51422485] {\n  border-radius: 4px;\n  border: solid 1px #eeeeee;\n  padding: .4rem .8rem;\n  color: #212529;\n  height: 32px;\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: 400;\n}\n.main-search .form-control[data-v-51422485]::placeholder {\n    color: #b2b2b2;\n}\n.main-ipp .label-ipp[data-v-51422485] {\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #9b9b9b;\n}\n.main-ipp .form-dropdown[data-v-51422485] {\n  border-radius: 4px;\n  border: solid 1px #eeeeee;\n  padding: .4rem .8rem;\n  color: #212529;\n  height: 32px;\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: 400;\n  min-width: 5rem;\n  margin-left: .25rem;\n}\nselect.form-control[size][data-v-51422485], select.form-control[multiple][data-v-51422485] {\n  height: 32px;\n}\n\n/*# sourceMappingURL=Pagination.vue.map */", map: {"version":3,"sources":["/home/dfilkovi/work/env_leapbit/lb-vue-pagination/src/Pagination.vue","Pagination.vue"],"names":[],"mappings":"AAkCA;EACA,oBAAA;AAAA;AADA;EAEA,eAAA;AAAA;AAFA;EAGA,mBAAA;AAAA;AAHA;EAIA,SAAA;AAAA;AAKA;EAGA,kBAAA;EACA,6CAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAAA;AAPA;IAYA,yBAAA;IACA,qBAAA;IACA,qBAAA;IACA,cAAA;AAAA;AAfA;IAqBA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,cAAA;IACA,oBAAA;AAAA;AA9BA;MAiCA,cAAA;AAAA;AAMA;EAGA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAAA;AAVA;IAaA,cAAA;AAAA;AAKA;EAGA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAAA;AAVA;EAcA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAA;AAKA;EACA,YAAA;AAAA;;ACvDA,yCAAyC","file":"Pagination.vue","sourcesContent":["<template>\n    <div class=\"lb-pagination\">\n        <div class=\"pagination-container d-flex flex-row flex-wrap col-sm-12\">\n            <div class=\"mr-2 main-ipp\">\n                <div class=\"d-flex flex-row align-content-center\">\n                    <label class=\"align-self-center mr-1 label-ipp\">{{getItemsPlaceholder}}:</label>\n                    <select v-model=\"value.limit\" size=\"0\" class=\"form-control input-normalheight form-dropdown\">\n                        <option>25</option>\n                        <option>50</option>\n                        <option>100</option>\n                        <option>200</option>\n                        <option>500</option>\n                        <option>1000</option>\n                        <option>2000</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"mr-2 main-search\">\n                <input type=\"text\" class=\"form-control\" v-model=\"value.query\" :placeholder=\"getSearchPlaceholder\">\n            </div>\n            <div class=\"toggle align-self-center mr-2\" v-on:click=\"reloadData\">\n                <svg data-v-b34144d8=\"\" version=\"1.1\" role=\"presentation\" width=\"20.57142857142857\" height=\"18\" viewBox=\"0 0 1536 1792\" style=\"font-size: 1.5em;\"><path d=\"M1511 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zM1536 256v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z\"></path></svg>\n            </div>\n            <div class=\"main-pagination\">\n                <b-pagination :total-rows=\"parseInt(totalCount)\" v-model=\"value.currentPage\" :per-page=\"parseInt(value.limit)\"></b-pagination>\n            </div>\n            \n\n        </div>\n    </div>\n</template>\n\n<style lang=\"scss\" scoped>\n\n    .pagination-container {\n        > div { margin-bottom: 1.5em; }\n        .toggle { cursor: pointer; }\n        label { white-space: nowrap; }\n        ul, label { margin: 0; }\n    }\n\n    \n\n    /deep/ .main-pagination {\n      \n      .pagination {\n      border-radius: 4px;\n      box-shadow: 0 1px 4px 0 rgba(72, 72, 72, 0.1);\n      border: solid 1px #eeeeee;\n      background-color: #ffffff;\n      height: 32px;\n\n        .page-item.active {\n\n          .page-link {\n            background-color: #fdde88;\n            border-color: #dee2e6;\n            border-radius: .25rem;\n            color: #212529;\n          }\n\n        }\n      \n        .page-link {\n          font-family: Roboto;\n          font-size: .8rem;\n          font-weight: 500;\n          font-stretch: normal;\n          font-style: normal;\n          line-height: normal;\n          letter-spacing: normal;\n          text-align: center;\n          color: #9b9b9b;\n          padding: .4rem .8rem;\n\n          &:hover {\n            color: #004b64;\n          }\n        }\n      }\n    }\n\n    .main-search {\n\n      .form-control {\n      border-radius: 4px;\n      border: solid 1px #eeeeee;\n      padding: .4rem .8rem;\n      color: #212529;\n      height: 32px;\n      font-family: Roboto;\n      font-size: .8rem;\n      font-weight: 400;\n\n      &::placeholder {\n      color: #b2b2b2;\n      }\n    }\n  }\n\n  .main-ipp {\n\n    .label-ipp {\n      font-family: Roboto;\n      font-size: .8rem;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: normal;\n      letter-spacing: normal;\n      color: #9b9b9b;\n    }\n\n    .form-dropdown {\n      border-radius: 4px;\n      border: solid 1px #eeeeee;\n      padding: .4rem .8rem;\n      color: #212529;\n      height: 32px;\n      font-family: Roboto;\n      font-size: .8rem;\n      font-weight: 400;\n      min-width: 5rem;\n      margin-left: .25rem;\n    }\n\n  }\n\n  select.form-control[size], select.form-control[multiple] {\n    height: 32px;\n  }\n\n</style>\n\n<script>\nexport default {\n  name: 'lb-vue-pagination',\n  data()\n  {\n    return {};\n  },\n  props: ['totalCount', 'value', 'searchPlaceholder', 'itemsPlaceholder'],\n  created()\n  {\n    var me = this;\n    me.reloadData();\n  },\n  watch:\n  {\n    'value.currentPage': function(val)\n    {\n      var me = this;\n      me.reloadData();\n    },\n    'value.limit': function(val)\n    {\n      var me = this;\n      me.reloadData();\n    },\n    'value.initialId': function(val)\n    {\n      var me = this;\n      console.log(val)\n      me.reloadData();\n    },\n    'value.query': function(val)\n    {\n      var me = this;\n\n      if(me.value.searchTimeout != false) clearTimeout(me.value.searchTimeout);\n\n      me.value.searchTimeout = setTimeout(function()\n      {\n        me.reloadData();\n        me.value.searchTimeout = false;\n      }, 300);\n    }\n  },\n  methods:\n  {\n    reloadData()\n    {\n      var me = this;\n      me.$emit('reload', null);\n    }\n  },\n  computed:\n  {\n    getSearchPlaceholder()\n    {\n      var me = this;\n\n      if(me.searchPlaceholder != undefined) return me.searchPlaceholder;\n      if(me.$t != undefined) return me.$t('SEARCH');\n      return 'Search';\n    },\n    getItemsPlaceholder()\n    {\n      var me = this;\n\n      if(me.itemsPlaceholder != undefined) return me.itemsPlaceholder;\n      if(me.$t != undefined) return me.$t('ITEMSPERPAGE');\n      return 'Items per page';\n    }\n  }\n}\n</script>\n",".pagination-container > div {\n  margin-bottom: 1.5em; }\n\n.pagination-container .toggle {\n  cursor: pointer; }\n\n.pagination-container label {\n  white-space: nowrap; }\n\n.pagination-container ul, .pagination-container label {\n  margin: 0; }\n\n/deep/ .main-pagination .pagination {\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(72, 72, 72, 0.1);\n  border: solid 1px #eeeeee;\n  background-color: #ffffff;\n  height: 32px; }\n  /deep/ .main-pagination .pagination .page-item.active .page-link {\n    background-color: #fdde88;\n    border-color: #dee2e6;\n    border-radius: .25rem;\n    color: #212529; }\n  /deep/ .main-pagination .pagination .page-link {\n    font-family: Roboto;\n    font-size: .8rem;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #9b9b9b;\n    padding: .4rem .8rem; }\n    /deep/ .main-pagination .pagination .page-link:hover {\n      color: #004b64; }\n\n.main-search .form-control {\n  border-radius: 4px;\n  border: solid 1px #eeeeee;\n  padding: .4rem .8rem;\n  color: #212529;\n  height: 32px;\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: 400; }\n  .main-search .form-control::placeholder {\n    color: #b2b2b2; }\n\n.main-ipp .label-ipp {\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #9b9b9b; }\n\n.main-ipp .form-dropdown {\n  border-radius: 4px;\n  border: solid 1px #eeeeee;\n  padding: .4rem .8rem;\n  color: #212529;\n  height: 32px;\n  font-family: Roboto;\n  font-size: .8rem;\n  font-weight: 400;\n  min-width: 5rem;\n  margin-left: .25rem; }\n\nselect.form-control[size], select.form-control[multiple] {\n  height: 32px; }\n\n/*# sourceMappingURL=Pagination.vue.map */"]}, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__ = "data-v-51422485";
    /* module identifier */
    var __vue_module_identifier__ = undefined;
    /* functional template */
    var __vue_is_functional_template__ = false;
    /* style inject SSR */
    

    
    var component = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      browser,
      undefined
    );

  // Import vue component

  exports.default = component;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
